import React from 'react';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';

import Button from '../button/button';
import EventDate from '../event-date/event-date';
import EventMeta from '../event-meta/event-meta';
import Link from '../link/link';

import styles from './content-teaser.module.scss';

import VenueLabel from '../venue-label/venue-label';
import DiningData from '../dining-data/dining-data';
import {DefaultTeaser} from '../default-teaser/default-teaser';
import {DiningTeaser} from '../dining-teaser/dining-teaser';

const ContentTeaser = ({ data }) => {
  // Grab the image.
  let image = null;
  {/* 2025 Update -- The field_image for newer items doesn't have the childImageSharp query
     if your image is null here you have to use the imageDerivatives query
     old code is comment out just in case it needs tob come back */}
  // if (
  //   data?.relationships?.field_image?.max_1600_16_9 || data?field_image?.imageDerivatives?.max_1600_16_9.href
  // ) {
  //   image = data.relationships.field_image.max_1600_16_9.childImageSharp;
  // }
  if (
    data?.relationships?.field_image?.max_1600_16_9 || 
    data?.field_image?.imageDerivatives?.links?.max_1600_16_9?.href
  ) {
    image = data?.relationships?.field_image?.max_1600_16_9?.childImageSharp || 
            data?.field_image?.imageDerivatives?.links?.max_1600_16_9?.href;
  }
  
  

  const eventMeta = {
    venue: data?.relationships?.venue?.name,
    series: data?.relationships?.series?.name
  };

  // For this component we want to provide a default format for dates if one isn't supplied.
  if (data?.date) {
    data.date.format = data.date.format ? data.date.format : data.date.full;
  }

  const distance = data?.relationships && data?.relationships.field_distance && data?.relationships.field_distance.metatag[0].attributes.content;
  const experience = data?.relationships && data?.relationships.field_experience && data?.relationships.field_experience.metatag[0].attributes.content;
  const cuisine = data?.relationships && data?.relationships.field_cuisine && data?.relationships.field_cuisine.map(cuisine => cuisine.metatag[0].attributes.content).join(', ');

  // create variable for node type name for easier logic to hide cta on dining
  const nodeTypeName = data?.relationships?.node_type?.name;
  const isDining = data?.__typename === 'node__dining';

  return (
    <article aria-label={data?.title} className={isDining ? styles.diningTeaser : styles.teaser}>
      {isDining ? (
        <DiningTeaser
          data={data}
          image={image}
          distance={distance}
          experience={experience}
          cuisine={cuisine}
        />
      ) : (
        <DefaultTeaser
          data={data}
          image={image}
          nodeTypeName={nodeTypeName}
          distance={distance}
          experience={experience}
          cuisine={cuisine}
          eventMeta={eventMeta}
        />
      )}
    </article>
  );
};

ContentTeaser.propTypes = {
  data: PropTypes.object.isRequired
};

export default ContentTeaser;